import React from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { TrendingUp, TrendingDown } from 'lucide-react';
import { LucideIcon } from 'lucide-react';
import { cn } from '@/lib/utils';

interface KPICardProps {
  title: string;
  value: string | number;
  subtitle: string;
  icon: LucideIcon;
  trend?: {
    value: number;
    isPositive: boolean;
  };
  variant?: 'default' | 'destructive' | 'secondary';
}

export function KPICard({
  title,
  value,
  subtitle,
  icon: Icon,
  trend,
  variant = 'default'
}: KPICardProps) {
  const variantStyles = {
    default: 'bg-card',
    destructive: 'bg-destructive/10 border-destructive/20',
    secondary: 'bg-secondary'
  };

  const iconStyles = {
    default: 'text-muted-foreground',
    destructive: 'text-destructive',
    secondary: 'text-secondary-foreground'
  };

  return (
    <Card className={cn(variantStyles[variant], "border")}>
      <CardContent className="pt-4 sm:pt-6">
        <div className="flex items-center justify-between">
          <Icon className={cn("h-6 w-6 sm:h-8 sm:w-8", iconStyles[variant])} />
          {trend && (
            <div className={trend.isPositive ? 'text-green-500' : 'text-red-500'}>
              {trend.isPositive ? (
                <TrendingUp className="h-3 w-3 sm:h-4 sm:w-4" />
              ) : (
                <TrendingDown className="h-3 w-3 sm:h-4 sm:w-4" />
              )}
            </div>
          )}
        </div>
        <div className="mt-3 sm:mt-4">
          <p className="text-lg sm:text-xl lg:text-2xl font-bold text-card-foreground">{value}</p>
          <p className="text-xs sm:text-sm font-medium text-muted-foreground">{title}</p>
          <p className="text-xs sm:text-sm text-muted-foreground mt-1">{subtitle}</p>
        </div>
      </CardContent>
    </Card>
  );
}

export default KPICard;
